export default __webpack_public_path__ + "static/media/MenuIconNav.6ebbac1f.svg";